var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{staticClass:"text-item",attrs:{"depressed":"","text":""},on:{"click":function($event){return _vm.$emit('syncItems')}}},[_vm._v(" "+_vm._s(_vm.$t("Sync items"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }